import { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';

// Keep the reader on the layer model, so switching between list and map retains it.
export default function GeoTiffLayer({ layer, zIndex, onError }) {
  const map = useMap();
  const mounted = useRef(null);
  useEffect(() => {
    const raster = new layer.RasterLayer({
      georaster: layer.georaster, pixelValuesToColorFn: layer.pixelValuesToColorFn, resolution: 128, opacity: layer.opacity,
      zIndex, keepBuffer: 1, updateWhenIdle: true,
    });
    const error = () => onError('Could not render part of this GeoTIFF. Try exporting a tiled GeoTIFF with overviews from your GIS software.');
    raster.on('tileerror', error);
    raster.addTo(map);
    mounted.current = raster;
    return () => { raster.off('tileerror', error); map.removeLayer(raster); mounted.current = null; };
  // Opacity and stacking changes do not recreate or decode the layer.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [map, layer.id, layer.georaster, layer.RasterLayer, onError]);
  useEffect(() => { mounted.current?.setOpacity(layer.opacity); mounted.current?.setZIndex(zIndex); }, [layer.opacity, zIndex]);
  return null;
}
